<template>
  <span>
    {{ (constContent && constContent !== 0) ? constContent_ : content}}
  </span>
</template>
<script>
export default {
  name: 'CountTimer',
  data () {
    return {
      timer: '',
      running: false,
      content: '00:00',
      hour: 0,
      minutes: 0,
      seconds: 0
    }
  },
  created () {
    this.timer = setInterval(this.start, 1000)
  },
  destroyed () {
    clearInterval(this.timer)
  },
  props: {
    constContent: {
      type: [Number],
      default: 0
    }
  },
  computed: {
    constContent_() {
      return this.renderConstContent(this.constContent)
    }
  },
  methods: {
    start () {
      this.seconds += 1
      if (this.seconds >= 60) {
        this.seconds = 0
        this.minutes = this.minutes + 1
      }
      if (this.minutes >= 60) {
        this.minutes = 0
        this.hour = this.hour + 1
      }
      this.content = (this.hour < 10 ? '0' + this.hour : this.hour) + ':' + (this.minutes < 10 ? '0' + this.minutes : this.minutes) + ':' + (this.seconds < 10 ? '0' + this.seconds : this.seconds)
    },
    startTimer () {
      this.timer = setInterval(this.start, 1000)
    },
    resetTimer () {
      this.hour = 0
      this.minutes = 0
      this.seconds = 0
      this.content = '00:00'
      this.stopTimer()
    },
    restartTimer(data) {
      if (data === 0) {
        this.hour = 0
        this.minutes = 0
        this.seconds = 0
      } else {
        this.hour = parseInt((data % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60))
        this.seconds = parseInt((data % (1000 * 60)) / 1000)
      }
      // this.timer = setInterval(this.start, 1000)
    },
    renderConstContent(data) {
      const minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = parseInt((data % (1000 * 60)) / 1000)
      return (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    currentTime() {
      return this.hour + ':' + this.minutes + ':' + this.seconds
    },
    notStart() {
      this.running = this.content === '00:00'
      return this.running
    }
  }
}
</script>
<style>
</style>
